import { useMutation } from "@tanstack/react-query";
import { z } from "zod/v4";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const submitFeedbackInputSchema = z.object({
  page_reference: z.string().nonempty(),
  comment: z.string().trim().min(1),
});

export type SubmitFeedbackInput = z.infer<typeof submitFeedbackInputSchema>;

export const submitFeedback = async ({ data }: { data: SubmitFeedbackInput }): Promise<void> => {
  await api.post("/carburate/feedback/", data);
};

type UseSubmitFeedbackOptions = {
  mutationConfig?: MutationConfig<typeof submitFeedback>;
};

export const useSubmitFeedback = ({ mutationConfig }: UseSubmitFeedbackOptions = {}) => {
  return useMutation({
    mutationFn: submitFeedback,
    ...mutationConfig,
  });
};
